import z from "zod";
import { USCheckboxFilterSchema } from "./base-schema";
import { USCheckboxValueOptionsSchema } from "./us-checkbox-options";

const WetlandTypeKeys = [
  "estuarine_and_marine_deepwater",
  "estuarine_and_marine_wetland",
  "freshwater_emergent_wetland",
  "freshwater_forested_or_shrub_wetland",
  "freshwater_pond",
  "lake",
  "other",
  "riverine",
] as const;

const WetlandTypeOptionValuesSchema = USCheckboxValueOptionsSchema(WetlandTypeKeys);

export const USWetlandSchema = USCheckboxFilterSchema.extend({
  id: z.literal("us-wetlands-id"),
  values: z.array(WetlandTypeOptionValuesSchema),
});
